import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, LoadingController, Loading } from 'ionic-angular';
import { APIOnLine } from '../../services/api/api.services';
import { iConfiguracion } from '../../models/basePage';

@IonicPage()
@Component({
  selector: 'page-modal-image',
  templateUrl: 'modal-image.html',
})
export class ModalImagePage {

  // #region Propiedades privadas
  public cargando: boolean = true;
  public carga: Loading;
  public dni: string = "";
  public imagen: string = "";
  // #endregion

  constructor(
    public CFutbolActas: APIOnLine.CFutbolActas,
    public loadingCtrl: LoadingController,
    public navCtrl: NavController,
    public navParams: NavParams,
    public Persistentes: APIOnLine.Persistentes
  ) {
    this.carga = this.loadingCtrl.create({
      content: "cargando foto",
      spinner: "dots"
    });
    this.carga.present();

    this.dni = this.navParams.get("dni");
    this.Persistentes.GetConfiguracion()
      .then((resultado: iConfiguracion) => {
        // Obtención de la ruta de la foto
        return this.CFutbolActas.fotoEnMiniatura(this.dni);
      })
      .then((resultado: string) => {
        this.imagen = resultado;
        this.cargando = false;
        this.carga.dismiss();
      })
      .catch(error => console.error(error));
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ModalImagePage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/modal-image/modal-image.ts